(function(){
    angular
        .module('app')
        .directive('datepicker', datepicker);

    datepicker.$inject = ['$timeout', '$parse','$compile']

    function datepicker($timeout, $parse,$compile){
        return {
              restrict: 'AE',
            require: 'ngModel',
            scope: {
                    horas: '=',
                    listadias: '='
                },
            link: function (scope, element, $attrs, ngModel) {
              
                return $timeout(function () {
                    var value = $attrs.value;
                    var tomorrow = new Date((new Date()).valueOf()+1000*60*60*24);
                    var $element = $(element);
                    var today = new Date()
                    var yesterday = new Date(today)
                    var timestampold =null;
                    yesterday.setDate(yesterday.getDate() - 1)
                    var picker;
                    var disable =   [{ from: [0,0,0], to: yesterday }];
                    //const date2 = [new Date('2023-7-26'),new Date('2023-7-27')];
                    var lastDay
                    scope.listadias.forEach(dia =>  {
                        if(dia.abierto == 0 )
                            disable.push(new Date(dia.diaVisita.split("/")[2]+"-"+dia.diaVisita.split("/")[1]+"-"+dia.diaVisita.split("/")[0] ));
                              
                            lastDay = new Date(dia.diaVisita.split("/")[2]+"-"+dia.diaVisita.split("/")[1]+"-"+dia.diaVisita.split("/")[0] );
                        }
                    );
      
                 
                    disable.push({ from: lastDay, to: [2999,1,1] })
                    function create(){
         
                      if(!ngModel.$modelValue)
                        {
                          $element.removeAttr( "data-value" );
          
                         
                        }
                    
             
                    picker = $element.pickadate({
          				      firstDay: 1,
          				      monthsFull: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
          				      weekdaysShort: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
                                today: '',
                                clear: '',
                                close: '',
                                disable: disable,
                                min:today,
                                max:lastDay,
                        
                              //disable:  [[6,7,26, 'inverted']],
          				      //enable: scope.listadias,
          				      onSet:function(thingSet) {
          				      	$timeout(function(){
                                 
                               
                                    var timestamp = thingSet.select + (3*60*60*1000);
                                
                                    if (timestamp == timestampold || timestamp == undefined || isNaN(timestamp)|| typeof timestamp =="string") {
                                        return
                                    }else{
                                      
                                      scope.$eval($attrs.ngChange);
                                     
                                      ngModel.$setViewValue(timestamp);
                                      scope.$emit('datepickerSet',{select:timestamp});
                                        
                                      timestampold = timestamp;
                                    }
                       
          				      	});
                                 return false;
          				      },
                              onStart: function() {
                                  // console.log('Hello there :)')
                                  scope.$emit('datepickerStart');
                              },
        			 });
                     scope.$emit('datepickerCreate');
                   }

                    // If the model changes, update the iCheck control.
                    scope.$watch($attrs.ngModel, function (newValue) {
                       // $element.iCheck('update');
                 
                       
                       //console.log( picker);
                            console.log(newValue);
                  
                        if (newValue != undefined && !isNaN(newValue) && typeof newValue !="string") 
                        {
                          
                            scope.$emit('datepickerChange',{select:newValue});
                            $element.pickadate("set",'select', newValue);
                            console.log(newValue);

                        }
                  
                       

                    });
                    create();
                    // console.log("create");
                   //eval($attrs.ngChange);
                });
            }
        };
    }
})();